import {
    LOYALTY_ESTIMATE_FETCH_START,
    LOYALTY_ESTIMATE_FETCH_SUCCESS,
    LoyaltyAction
} from 'actions/loyalty/LoyaltyActionsTypes';
import { initialLoyaltyState, LoyaltyState } from 'reducers/loyalty/LoyaltyState';
import { Reducer } from 'redux';

export const loyaltyReducer: Reducer<LoyaltyState, LoyaltyAction> = (
    state = initialLoyaltyState,
    action
) => {
    switch (action.type) {
        case LOYALTY_ESTIMATE_FETCH_START:
            return {
                ...state,
                loading: true
            };
        case LOYALTY_ESTIMATE_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                estimate: action.payload.estimate
            };
        default:
            return state;
    }
};
